export const SELECTORS = {
  CONTAINER: 'js-anchor-navigation',
  HEADER: 'js-anchor-navigation-header',
  LINKS: 'js-anchor-navigation-links',
  LINK: 'js-anchor-navigation-link'
};

export const CLASSES = {
  LINK_SELECTED: 'anchor-navigation__link--selected',
  LINKS_FIXED: 'anchor-navigation--links-fixed'
};
